if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.domCache = {};
        this.isSubmitting = false;

        this.form = this.querySelector('form');
        this.csStickyButton = document.querySelector('rocket-product-sticky-button') || null;
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.spinner = this.form.querySelector('.look-book-product__btn .loading-overlay__spinner');

        this.handleVariantSelectAndAddToCart();
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.isSubmitting) return;
        this.isSubmitting = true;

        if (!this.domCache.variantIdInput) {
          this.domCache.variantIdInput = this.form.querySelector('[name=id]');
          this.domCache.rocketVariantSelected = document.querySelector('rocket-cs-variant-selected');
        }

        if (!this.domCache.variantIdInput.value) {
          this.domCache.rocketVariantSelected?.classList.add('variant-missing');
          this.isSubmitting = false;
          return;
        } else {
          this.domCache.rocketVariantSelected?.classList.remove('variant-missing');
        }

        if (this.submitButton.getAttribute('aria-disabled') === 'true' && !this.selectedVariantItem) {
          this.isSubmitting = false;
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.spinner?.classList.remove('hidden');
        /*     this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        ); */

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              if (this.selectedVariantItem) {
                const detailsEl = this.selectedVariantItem.closest('details');
                const messageEl = detailsEl?.previousElementSibling;
                if (messageEl && messageEl.classList.contains('message-error')) {
                  messageEl.classList.remove('hidden');
                  messageEl.textContent = response.description;
                }
              }

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.submitButton.classList.add('btn--disabled');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }

            requestIdleCallback(
              () => {
                this.handleTeamStoreValidation();
              },
              { timeout: 100 }
            );

            document.body.classList.remove('open-model-drawer');

            if (!this.domCache.quickaddDrawer) {
              this.domCache.quickaddDrawer = document.querySelector('.rocket-quickadd-drawer');
            }
            if (this.domCache.quickaddDrawer) {
              this.domCache.quickaddDrawer.innerHTML = '';
            }
          })
          .catch((e) => {
            console.error(e);
            this.isSubmitting = false;
          })
          .finally(() => {
            requestAnimationFrame(() => {
              this.submitButton.classList.remove('loading');

              if (!this.domCache.stickyButton) {
                this.domCache.stickyButton = document.querySelector('rocket-product-sticky-button');
              }

              if (this.domCache.stickyButton) {
                this.domCache.stickyButton.classList.remove('loading');
                const loadingSpinner = this.domCache.stickyButton.querySelector('.loading-overlay__spinner');
                loadingSpinner?.classList.add('hidden');
              }

              if (this.cart?.classList.contains('is-empty')) {
                this.cart.classList.remove('is-empty');
              }

              if (!this.error) {
                this.submitButton.removeAttribute('aria-disabled');
              }

              this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
              this.spinner?.classList.add('hidden');
              this.selectedVariantItem = null;
              this.isSubmitting = false;

              if (!this.domCache.headerSearch) {
                this.domCache.headerSearch = document.querySelector('.header__search details');
              }
              this.domCache.headerSearch?.removeAttribute('open');
            });

            requestIdleCallback(
              () => {
                if (typeof getMostExpensiveProductId === 'function') {
                  const mostExpensiveId = getMostExpensiveProductId();
                  if (typeof mostExpensiveId === 'string' && typeof getProductRelated === 'function') {
                    getProductRelated('gid://shopify/Product/' + mostExpensiveId);
                  }
                }

                if (window._swat?.initializeActionButtons) {
                  _swat.initializeActionButtons('body');
                }

                if (window.initButtonHoverEffects) {
                  window.initButtonHoverEffects();
                }
              },
              { timeout: 500 }
            );
          });
      }

      handleTeamStoreValidation() {
        const cartItems = document.querySelectorAll('.cart-item');
        let trueFound = false;
        let falseFound = false;

        for (const item of cartItems) {
          const teamStoreValue = item.getAttribute('data-team-store-drawer');
          if (teamStoreValue === 'true') trueFound = true;
          else if (teamStoreValue === 'false') falseFound = true;

          if (trueFound && falseFound) break;
        }

        if (trueFound && falseFound) {
          if (!this.domCache.checkoutButton) {
            this.domCache.checkoutButton = document.getElementById('CartDrawer-Checkout');
            this.domCache.drawerPopup = document.getElementById('drawer-popup');
          }

          this.domCache.checkoutButton?.setAttribute('disabled', 'disabled');
          if (this.domCache.drawerPopup) {
            this.domCache.drawerPopup.style.display = 'block';
          }
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');

        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        if (this.csStickyButton?.querySelector('.sticky_buy_buttons__custom--message')) {
          this.csStickyButton
            .querySelector('.sticky_buy_buttons__custom--message')
            .toggleAttribute('hidden', !errorMessage);
        }

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;

          const stickyErrorMsg = this.csStickyButton?.querySelector(
            '.sticky_buy_buttons__custom--message .product-form__error-message'
          );
          if (stickyErrorMsg) {
            stickyErrorMsg.textContent = errorMessage;
          }
        }
      }

      handleVariantSelectAndAddToCart() {
        const variantItems = this.form.querySelectorAll('.js-variant-item');
        const variantID = this.form.querySelector('[name=id]');
        const variantTitle = this.form.querySelector('.js-selected-variant');

        if (!variantItems.length || !variantID) return;

        variantItems.forEach((variant) => {
          variant.addEventListener(
            'click',
            () => {
              requestAnimationFrame(() => {
                const id = variant.dataset.id;
                const title = variant.dataset.title;

                variantID.value = id;
                if (variantTitle) {
                  variantTitle.textContent = title;
                }

                this.selectedVariantItem = variant;

                if (!this.domCache.rocketVariantSelected) {
                  this.domCache.rocketVariantSelected = document.querySelector('rocket-cs-variant-selected');
                }

                if (this.domCache.rocketVariantSelected && id) {
                  this.domCache.rocketVariantSelected.classList.remove('variant-missing');
                }

                const errorMessages = this.form.querySelectorAll('.message-error');
                errorMessages.forEach((msg) => {
                  msg.classList.add('hidden');
                  msg.textContent = '';
                });

                if (window.innerWidth >= 768) {
                  this.form.dispatchEvent(
                    new Event('submit', {
                      bubbles: true,
                      cancelable: true,
                    })
                  );
                }
              });
            },
            { passive: true }
          );
        });
      }
    }
  );
}
